module.exports = __webpack_public_path__ + "img/slide-1.a3a08a7f.png";